module.exports = __webpack_public_path__ + "img/wild_table.45764234.png";